import React from "react";
import PropTypes from "prop-types";
import DataGrid, { DataGridItem } from "components/data-grid";
import { injectIntl } from "react-intl";
import withStyles from "components/with-styles";
import styles from "../styles/source-data.css.js";
import { TextDisplay } from "components/display-data";
import { ExternalLink } from "components/link";

const AdminData = ({ classes, source, intl }) => {
  return (
    source.publicInterface && (
      <DataGrid>
        <DataGridItem big className={classes.overflow}>
          <TextDisplay label={intl.formatMessage({ id: "source.interface.streamTcpUrl" })}>
            <ExternalLink href={source.publicInterface.streamTcpUrl}>
              {source.publicInterface.streamTcpUrl}
            </ExternalLink>
          </TextDisplay>
        </DataGridItem>
        <DataGridItem big className={classes.overflow}>
          <TextDisplay label={intl.formatMessage({ id: "source.interface.adminUrl" })}>
            <ExternalLink href={source.publicInterface.adminUrl}>{source.publicInterface.adminUrl}</ExternalLink>
          </TextDisplay>
        </DataGridItem>
      </DataGrid>
    )
  );
};

AdminData.propTypes = {
  /**
   * Data to represent
   **/
  source: PropTypes.object,
  /**
   * Callback que se invoca al clicar el botón de checkear el estado de la cámara
   **/
  onCheckStatus: PropTypes.func,
};

export default injectIntl(withStyles(styles)(AdminData));
